import { render, staticRenderFns } from "./AddRegulation.vue?vue&type=template&id=438d07d2"
import script from "./AddRegulation.vue?vue&type=script&lang=js"
export * from "./AddRegulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports